<template>
  <div>
    <div v-if="selectedListing">
      <listing :listing="selectedListing" @saved="load" class="mt-4">
        <template slot="actions">
          <button @click="selectedListing = null" class="recruitment-button bg-secondary text-white">
            Back to Listings
          </button>
        </template>
      </listing>
    </div>
    <div v-else-if="applicationsListing">
      <applications class="mt-4" :listing="applicationsListing">
        <template slot="actions">
          <button @click="applicationsListing = null" class="recruitment-button bg-secondary text-white">
            Back to Listings
          </button>
        </template>
      </applications>
    </div>
    <div v-else>
      <button @click="newListing" class="recruitment-button bg-tertiary text-white">
        New Listing
      </button>
      <listings :listings="listings" @select-listing="select" @select-applications="applications" @page-changed="page = $event" class="recruitment-section" />
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState, mapActions } from 'vuex'
import RecruitmentListings from '@/product-modules/recruitment/RecruitmentListings'
import RecruitmentListing from '@/product-modules/recruitment/RecruitmentListing'
import RecruitmentApplications from '@/product-modules/recruitment/RecruitmentApplications'

export default {
  components: {
    'listings': RecruitmentListings,
    'listing': RecruitmentListing,
    'applications': RecruitmentApplications
  },

  data () {
    return {
      loading: false,
      listings: [],
      selectedListing: null,
      applicationsListing: null,
      jobTypeOptions: [],
      page: 1
    }
  },

  computed: {
    ...mapState([
      'profile',
      'selectedOffice'
    ])
  },

  methods: {
    ...mapActions([ 'displayToastNotification' ]),

    load () {
      this.loading = true

      if (!this.selectedOffice.id) {
        return
      }

      const params = this.profile.type <= 2 ? { fields: 'office(name),applications_count,image_url,applications(cv_url,cover_letter_url,other_document_urls)', page: this.page } : { office_id: this.selectedOffice.id, fields: 'applications_count,image_url,applications(cv_url,cover_letter_url,other_document_urls)', page: this.page }

      v2Api
        .get('/recruitment-listings', { params: params })
        .then(response => {
          this.listings = response.data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.displayToastNotification({
            type: 'warning',
            icon: 'fa-exclamation-triangle',
            title: 'Unable to load listings',
            info: `We've been unable to fetch your listings at this time.`
          })
        })
    },

    select (event) {
      this.selectedListing = event
    },

    applications (event) {
      this.applicationsListing = event
    },

    newListing () {
      this.selectedListing = {
        job_title: null,
        job_type: null,
        job_department: null,
        salary: null,
        summary: null,
        description: null,
        contact_name: null,
        contact_number: null,
        contact_email: null,
        display_address: null,
        image: null,
        image_url: null
      }
    }
  },

  created () {
    this.load()
  },

  watch: {
    profile () {
      this.page = 1
    },

    selectedOffice () {
      this.page = 1
    },

    page () {
      this.load()
    }
  }
}
</script>

<style lang="sass">
.recruitment-section
  @apply mt-4 p-6 rounded-lg bg-white
.recruitment-button
  @apply mr-4 py-2 px-6 rounded
  transition: background .5s
  &--small
    @apply text-sm px-4
</style>
